import 'modernizr'; // eslint-disable-line
import '../bootstrap';

import accessibility from '../modules/accessibility';
import tracking from '../modules/tracking';
import formValidation from '../modules/formValidation';
import navigation from '../modules/navigation';
// import toTop from '../modules/toTop';
// import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import datepicker from '../modules/datepicker';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import videoElement from '../modules/videoElement';
// import controlledInput from '../modules/controlledInput';
import header from '../modules/header';
import cardSlider from '../modules/cardSlider';
import photoSlider from '../modules/photoSlider';
import tabBar from '../modules/tabBar';
import starSelector from '../modules/starSelector';
import searchInput from '../modules/searchInput';
import hero from '../modules/hero';
import mapOverlay from '../modules/mapOverlay';
import actionPopup from '../modules/actionPopup';
import searchComplete from '../modules/searchComplete';
import topList from '../modules/topList';
import destinationsSlider from '../modules/destinationsSlider';
import destinationLayout from '../modules/destinationLayout';
import travelTypeFilter from '../modules/travelTypeFilter';
import destinationBlock from '../modules/destinationBlock';
import review from '../modules/review';
import quiz from '../modules/quiz';
import accordion from '../modules/accordion';
import answerCollapse from '../modules/answerCollapse';
import mapPreClickOverlay from '../modules/mapPreClickOverlay';

import scrollListener from '../helpers/scrollListener';
// insert-import

const general = () => {
  const app: any = {};

  tracking.initialize();
  app.accessibility = new accessibility();
  app.formValidation = new formValidation();
  // toTop.initialize();
  // videoOverlay.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  datepicker.initialize();
  cookieBar.initialize();
  embedWrap();
  whatsapp.initialize();
  videoElement.initialize();
  // controlledInput.initialize();
  navigation.initialize();
  header.initialize();
  cardSlider.initialize();
  photoSlider.initialize();
  tabBar.initialize();
  starSelector.initialize();
  searchInput.initialize();
  hero.initialize();
  mapOverlay.initialize();
  actionPopup.initialize();
  searchComplete.initialize();
  topList.initialize();
  destinationsSlider.initialize();
  destinationLayout.initialize();
  travelTypeFilter.initialize();
  destinationBlock.initialize();
  review.initialize();
  quiz.initialize();
  accordion.initialize();
  answerCollapse.initialize();
  mapPreClickOverlay.initialize();

  scrollListener.start();
  // insert-definition
};

export default general;
